module.exports = __webpack_public_path__ + "img/thunderstorm-dark.ddd9cd80.png";